import React from "react";

export default function Checkbox(props) {
    return (
        <i className={props.checked ? 'fa fa-check-square-o' : 'fa fa-square-o'} />
    )
}